import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import * as DateFns from 'date-fns';

import Navbar from '../Navbar/NavBar';
import MonthSchedule from './MonthSchedule/MonthSchedule';
import WeekSchedule from './WeekSchedule/Week/WeekView';
import HeaderSchedule from './HeaderSchedule/HeaderSchedule';
import { FORMAT_DATE_ROUTE, SCOPE } from '../../config/constants';
import { routeToDate, routeToScheduleScope, saveDataEventsOnLocalStorage } from '../../helpers';
import { useRouter } from '../../helpers/customHooks';
import { ScheduleEvent } from '../../config/commonTypes';
import { useEventsDispatch, useEventsState } from '../../store/hooks/events';

const Schedule = () => {

  const { pathname, scope } = useRouter();
  const onlyDatePath = pathname.split('/').slice(0, 6).join('/');
  const { loadEvents } = useEventsDispatch();
  const scheduleScope = routeToScheduleScope(onlyDatePath);
  const viewDate = routeToDate(onlyDatePath, 3);
  const isMobile = window.matchMedia("only screen and (max-width: 900px)").matches;
  const events: ScheduleEvent[] = [
    ...useEventsState(`/schedule/month/${DateFns.format(DateFns.addMonths(viewDate, 1), FORMAT_DATE_ROUTE)}`), // last month
    ...useEventsState(onlyDatePath), // actual month
    ...useEventsState(`/schedule/month/${DateFns.format(DateFns.subMonths(viewDate, 1), FORMAT_DATE_ROUTE)}`) // next month
  ];
  const selectedDate = routeToDate(pathname);
  const [clearFetch, setClearFetch] = useState(false);
  const nowDate = new Date();

  useEffect(() => {
    if(selectedDate.getFullYear !== nowDate.getFullYear){
      setClearFetch(true);
    }else{
      if( selectedDate.getMonth()+1 !== nowDate.getMonth()+1){
        setClearFetch(true);
      }else{
        setClearFetch(false);
      }
    }
    saveDataEventsOnLocalStorage(events.map(event => Number.isNaN(+event.gameId) ? event._id : event.gameId));
  }, [events]);

  useEffect(loadEvents(true, false, true, true, isMobile), [pathname, scheduleScope]);

  return (
    <>
      <Navbar />
      <Container className="container-00">
        <Row>
          <Col lg={12} xs={12}>
            <HeaderSchedule clearFetch={clearFetch} />
            {scope === SCOPE.SCHEDULE.MONTH.PAGE ? <MonthSchedule /> : <WeekSchedule />}
          </Col>
        </Row>
      </ Container>
    </>
  );
};

export default Schedule;
